import { useCallback } from 'react';

import { QueryParam } from '~/common/types';
import { useEncodedQuery, useLocationSearchParams, usePersistedQuery } from '~/hooks';

import {
  UseDataGridQueryBuilderQueryProps,
  UseDataGridQueryBuilderQueryResult,
} from './useDataGridQueryBuilderState.types';

export const useDataGridQueryBuilderQuery = ({
  domain,
}: UseDataGridQueryBuilderQueryProps): UseDataGridQueryBuilderQueryResult => {
  const [
    {
      //
      [QueryParam.QUERY]: queryId,
      [QueryParam.ENCODED_QUERY]: encodedQuery,
    },
    setSearchParam,
  ] = useLocationSearchParams();
  const [query, setQuery, { rulesTotal }] = usePersistedQuery(domain, queryId);
  useEncodedQuery(domain, encodedQuery, setQuery);

  const onQueryIdChange = useCallback((queryId: string) => {
    setSearchParam((prev) => {
      // toggle if the same query is selected again
      const next = prev[QueryParam.QUERY] === queryId ? undefined : queryId;
      // remove query param if filter gets cleared
      if (!next) {
        setQuery(undefined);
      }
      return { ...prev, [QueryParam.QUERY]: next };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loading: !!encodedQuery,
    query,
    queryId,
    rulesTotal,
    onQueryChange: setQuery,
    onQueryIdChange,
  };
};
